import { CREATORS } from "./creators";

const by = (id) => CREATORS.find((c) => c.id === id);

export const DEMO_FAN = { tokens: 3100, usd: 30.69, memberSince: "2026-06-01", verified: true };

export const TOKEN_PACKS = [
  { tokens: 500, usd: 4.99 },
  { tokens: 1000, usd: 9.99 },
  { tokens: 3000, usd: 27.99 },
  { tokens: 10000, usd: 89.99 },
];

export const FEED = [
  { id: "f1", creator: by("kai-moreno"), type: "LIVE", price: null, sub: true, when: "2026-09-18T19:00", title: { en: "Live training — subscribers only", es: "Entrenamiento en vivo — solo suscriptores" } },
  { id: "f2", creator: by("luna-vega"), type: "RELEASE", price: 550, units: "100 / 100", title: { en: "Midnight — Launch bundle", es: "Midnight — Bundle de lanzamiento" } },
  { id: "f3", creator: by("dante-ruiz"), type: "PPV", price: 320, title: { en: "Unreleased track: Neon Rain (full)", es: "Tema inédito: Neon Rain (completo)" } },
  { id: "f4", creator: by("mia-castell"), type: "COLLECTION", price: 1200, pieces: 24, title: { en: "Lisbon travel collection", es: "Colección de viaje: Lisboa" } },
  { id: "f5", creator: by("noa-rivers"), type: "SERIES", price: 150, episode: "Ep. 4 / 8", title: { en: "Ink & Light — Episode 4", es: "Ink & Light — Episodio 4" } },
  { id: "f6", creator: by("ari-blanco"), type: "POST", price: 0, unlocked: true, title: { en: "Lookbook preview — free for followers", es: "Adelanto del lookbook — gratis para seguidores" } },
];

export const DROPS = [
  { id: "d1", creator: by("luna-vega"), status: "live", units: "100 / 100", price: 550, title: { en: "Midnight bundle", es: "Bundle Midnight" } },
  { id: "d2", creator: by("kai-moreno"), status: "live", units: "13 / 50", price: 890, title: { en: "12-week plan + private live", es: "Plan 12 semanas + live privado" } },
  { id: "d3", creator: by("sol-ferrer"), status: "presale", units: "100 / 100", price: 400, title: { en: "Breathwork series — presale", es: "Serie de respiración — preventa" } },
  { id: "d4", creator: by("ari-blanco"), status: "soldout", units: "0 / 25", price: 1500, title: { en: "Signed lookbook edition", es: "Edición firmada del lookbook" } },
];

export const FOLLOWING = [
  { creator: by("kai-moreno"), subscribed: true, priceUsd: 9.99, renews: "2026-10-12" },
  { creator: by("luna-vega"), subscribed: true, priceUsd: 14.99, renews: "2026-10-03" },
  { creator: by("dante-ruiz"), subscribed: false },
  { creator: by("mia-castell"), subscribed: false },
  { creator: by("noa-rivers"), subscribed: true, priceUsd: 6.99, renews: "2026-09-28" },
];

export const COLLECTIONS = [
  { id: "c1", creator: by("mia-castell"), pieces: 24, paid: 1200, date: "2026-09-02", title: { en: "Lisbon travel collection", es: "Colección de viaje: Lisboa" } },
  { id: "c2", creator: by("noa-rivers"), pieces: 8, paid: 600, date: "2026-08-21", title: { en: "Ink & Light — Season 1", es: "Ink & Light — Temporada 1" } },
  { id: "c3", creator: by("luna-vega"), pieces: 12, paid: 550, date: "2026-08-10", title: { en: "Golden hour set", es: "Set golden hour" } },
];

export const THREADS = [
  { id: "t1", creator: by("kai-moreno"), last: { en: "See you at the live tonight!", es: "¡Nos vemos en el live esta noche!" }, time: "18:42", unread: 2 },
  { id: "t2", creator: by("luna-vega"), last: { en: "New bundle just dropped 🎞", es: "Acaba de salir el nuevo bundle 🎞" }, time: "12:10", unread: 0 },
  { id: "t3", creator: by("noa-rivers"), last: { en: "Thanks for collecting season 1!", es: "¡Gracias por coleccionar la temporada 1!" }, time: "Mon", unread: 0 },
];

export const MESSAGES = [
  { id: "m1", from: "creator", text: { en: "Hey! Thanks for subscribing. Tonight's live starts at 19:00.", es: "¡Hola! Gracias por suscribirte. El live de hoy empieza a las 19:00." }, time: "18:20" },
  { id: "m2", from: "me", text: { en: "Perfect, I'll be there. Is the 12-week plan still available?", es: "Perfecto, ahí estaré. ¿Sigue disponible el plan de 12 semanas?" }, time: "18:31" },
  { id: "m3", from: "creator", ppv: 890, text: { en: "Yes — here's the full plan + private live access.", es: "Sí — aquí está el plan completo + acceso al live privado." }, time: "18:40" },
  { id: "m4", from: "creator", text: { en: "See you at the live tonight!", es: "¡Nos vemos en el live esta noche!" }, time: "18:42" },
];

export const TRANSACTIONS = [
  { id: "x1", date: "2026-09-15", kind: "topup", tokens: 3000, usd: 27.99, desc: { en: "Token pack (3,000) — card •••• 4242", es: "Paquete de tokens (3.000) — tarjeta •••• 4242" } },
  { id: "x2", date: "2026-09-12", kind: "sub", tokens: null, usd: 9.99, desc: { en: "Subscription renewal — Kai Moreno", es: "Renovación de suscripción — Kai Moreno" } },
  { id: "x3", date: "2026-09-02", kind: "unlock", tokens: -1200, usd: null, desc: { en: "Collection unlock — Lisbon travel collection", es: "Desbloqueo de colección — Lisboa" } },
  { id: "x4", date: "2026-08-21", kind: "unlock", tokens: -600, usd: null, desc: { en: "Series unlock — Ink & Light S1", es: "Desbloqueo de serie — Ink & Light T1" } },
  { id: "x5", date: "2026-08-10", kind: "unlock", tokens: -550, usd: null, desc: { en: "Release unlock — Golden hour set", es: "Desbloqueo de lanzamiento — Golden hour set" } },
  { id: "x6", date: "2026-08-01", kind: "topup", tokens: 1000, usd: 9.99, desc: { en: "Token pack (1,000) — card •••• 4242", es: "Paquete de tokens (1.000) — tarjeta •••• 4242" } },
];

export const STUDIO = {
  creator: by("kai-moreno"),
  earnings30: 4860.5,
  subscribers: 412,
  unlocks30: 318,
  pending: 1290.4,
  available: 2130.75,
  nextPayout: "2026-09-30",
  feeCreator: 80,
  feePlatform: 20,
  holdingDays: 7,
  top: [
    { title: { en: "12-week plan + private live", es: "Plan 12 semanas + live privado" }, type: "RELEASE", revenue: 1860.2, sales: 37 },
    { title: { en: "Monthly subscription", es: "Suscripción mensual" }, type: "SUB", revenue: 1540.0, sales: 412 },
    { title: { en: "Mobility series — 8 episodes", es: "Serie de movilidad — 8 episodios" }, type: "SERIES", revenue: 890.3, sales: 121 },
    { title: { en: "Live training replay", es: "Repetición del entrenamiento en vivo" }, type: "PPV", revenue: 570.0, sales: 95 },
  ],
  payouts: [
    { date: "2026-09-15", usd: 2410.6, status: "paid" },
    { date: "2026-08-31", usd: 2185.0, status: "paid" },
    { date: "2026-08-15", usd: 1990.4, status: "paid" },
  ],
};
